import { combineReducers } from 'redux';

import damageViewer from './damageViewer';

export { getImage, getImages } from './damageViewer';

export default combineReducers({
  damageViewer,
});
